export default __webpack_public_path__ + "static/media/icon_search.77fb0157.svg";